import { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';

const ContactDealerInlineForm = lazy(
    () => import(/* webpackChunkName: "ContactDealerInlineForm" */ './ContactDealerInlineForm.jsx')
);

export const ContactDealerInlineFormLoader = ({ load, fallback = '', ...props }) => {
    return (
        <>
            {load && (
                <Suspense fallback={fallback}>
                    <ContactDealerInlineForm {...props} />
                </Suspense>
            )}
        </>
    );
};

ContactDealerInlineFormLoader.propTypes = {
    load: PropTypes.bool,
    fallback: PropTypes.node,
};
